export enum summaryTypes {
    FETCH_SUMMARY_REQUEST = "FETCH_SUMMARY_REQUEST",
    FETCH_SUMMARY_SUCCESS = "FETCH_SUMMARY_SUCCESS",
    FETCH_SUMMARY_FAILURE = "FETCH_SUMMARY_FAILURE",
  }